/*
 * Site-wide. Drops a decorative layer of smoke, bubbles and sparkles into every
 * lavender-scheme block (scheme-9a0b2d73). Styling lives in pv-lavender-bubbles.css.
 */
(() => {
  // Skip .media wrappers: the image covers the whole box, so a layer there is never seen.
  const SELECTOR = '.color-scheme-9a0b2d73-3e9b-4536-9de2-9d6ed721f187:not(.media)';
  const TINTS = ['181, 147, 232', '146, 102, 214', '255, 143, 191', '255, 255, 255'];

  // Pause animations for layers that are off-screen, so long pages stay light.
  const visibility =
    'IntersectionObserver' in window
      ? new IntersectionObserver((entries) =>
          entries.forEach((entry) => entry.target.classList.toggle('is-paused', !entry.isIntersecting))
        )
      : null;

  const rand = (min, max) => min + Math.random() * (max - min);
  const pick = (list) => list[Math.floor(Math.random() * list.length)];

  const makeSpan = (className, vars) => {
    const span = document.createElement('span');
    span.className = className;
    Object.entries(vars).forEach(([key, value]) => span.style.setProperty(`--${key}`, value));
    return span;
  };

  const decorate = (host) => {
    if (host.querySelector(':scope > .pv-bubbles')) return;
    const { width, height } = host.getBoundingClientRect();
    if (width < 120 || height < 120) return;

    // Scale the amount with the block's area so small cards don't get crowded.
    const density = Math.min(1, (width * height) / (900 * 500));
    const layer = document.createElement('div');
    layer.className = 'pv-bubbles';
    layer.setAttribute('aria-hidden', 'true');

    for (let i = 0; i < Math.round(2 + density * 3); i++) {
      const size = rand(0.35, 0.7) * Math.min(width, height);
      layer.append(
        makeSpan('pv-smoke', {
          size: `${size}px`,
          x: `${rand(-15, 85)}%`,
          y: `${rand(-20, 70)}%`,
          tint: pick(TINTS.slice(0, 3)),
          dx: `${rand(-60, 60)}px`,
          dy: `${rand(-40, 40)}px`,
          dur: `${rand(9, 16)}s`,
          delay: `${rand(-10, 0)}s`,
        })
      );
    }

    for (let i = 0; i < Math.round(4 + density * 10); i++) {
      layer.append(
        makeSpan('pv-bubble', {
          size: `${rand(10, 34)}px`,
          x: `${rand(2, 95)}%`,
          dx: `${rand(-30, 30)}px`,
          travel: `${height * rand(0.9, 1.3)}px`,
          dur: `${rand(8, 16)}s`,
          delay: `${rand(-16, 0)}s`,
        })
      );
    }

    for (let i = 0; i < Math.round(3 + density * 7); i++) {
      layer.append(
        makeSpan('pv-sparkle', {
          size: `${rand(8, 16)}px`,
          x: `${rand(3, 95)}%`,
          y: `${rand(5, 92)}%`,
          tint: pick(['255, 255, 255', '255, 143, 191', '146, 102, 214']),
          dur: `${rand(2.5, 5)}s`,
          delay: `${rand(-5, 0)}s`,
        })
      );
    }

    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.classList.add('pv-bubbles-host');
    host.append(layer); // last child, so the theme's `> * + *` spacing doesn't shift the first real child
    if (visibility) visibility.observe(layer);
  };

  const run = (root = document) => root.querySelectorAll(SELECTOR).forEach(decorate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
